/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isCanada } from '@tcp/core/src/utils/utils';
import ResetPasswordTopSection from '../molecules/ResetPasswordTopSection';
import ResetPasswordForm from '../molecules/ResetPasswordForm';
import ResetPasswordPinSection from '../molecules/ResetPasswordPinSection';
import ResetPasswordResendEmail from '../molecules/ResetPasswordResendEmail';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_PASSWORD_LABELS,
  GlobalPasswordsLabels,
} from '../../../../../utils/labels/globalPassword.labels';

export const ResetPassword = ({
  successMessage,
  errorMessage,
  onSubmit,
  onBack,
  showNotification,
  resetPasswordErrorMessage,
  isFormSubmitting,
  passwordValidationCodeValid,
  setpasswordValidationCode,
  fullPageView,
  email,
  showRecaptcha,
  resetPasswordAction,
  codeExpired,
  resetStateAction,
  resentMessageThreshold,
  selectedPassResetOption,
  maskedPhoneNumber,
  isResetViaText,
  setPassResetOption,
  setPasswordValidationDefaultState,
  isRecaptchaError,
  isShowRecaptchaError,
  setIsShowRecaptchaError,
  loginInprogress,
  phoneCountryCode,
  loginFlowUXEnhancementEnabled,
}) => {
  const isSafari =
    typeof window !== 'undefined' &&
    (window?.safari !== undefined || window?.navigator?.vendor?.includes('Apple'));
  const [verificationCodeSent, setVerificationCodeSent] = useState(false);
  const [resetPinField, setResetPinField] = useState(false);
  const resendEmail = () => {
    setVerificationCodeSent(true);
    resetPasswordAction({
      logonIdResend: email.toUpperCase().trim(),
      target: selectedPassResetOption,
    });
  };
  const resendViaOption = (option) => {
    setPasswordValidationDefaultState('na');
    setResetPinField(true);
    resetStateAction();
    setVerificationCodeSent(true);
    setPassResetOption(option);
    resetPasswordAction({
      logonIdResend: email.toUpperCase().trim(),
      target: option,
    });
  };

  const {
    lbl_phone_otp_not_received_content: lblPhoneOtpNotReceived,
    lbl_resend_it: lblResendIt,
    lbl_send_code_via_email_address: lblSendCodeViaEmail,
    lbl_didnt_receive_otp_sent_to_phone: lblDidntReceiveOtpPhone,
    lbl_send_code_via_phone: lblSendCodeViaPhone,
  } = getLabelFromCopyOrFromTranslation(GLOBAL_PASSWORD_LABELS, GlobalPasswordsLabels);

  const isSmsSelected = selectedPassResetOption === 'sms';
  const showSMSOption = phoneCountryCode ? phoneCountryCode === '+1' : true;
  return (
    <React.Fragment>
      <ResetPasswordTopSection
        onBack={onBack}
        className="elem-mb-XL"
        fullPageView={fullPageView}
        isSmsSelected={isSmsSelected}
        isResetViaText={isResetViaText}
        email={email}
        maskedPhoneNumber={maskedPhoneNumber}
        loginFlowUXEnhancementEnabled={loginFlowUXEnhancementEnabled}
      />

      {fullPageView && (
        <ResetPasswordPinSection
          setpasswordValidationCode={setpasswordValidationCode}
          passwordValidationCodeValid={passwordValidationCodeValid}
          errorMessage={errorMessage}
          isResetViaText={isResetViaText}
          resetPinField={resetPinField}
          setResetPinField={setResetPinField}
          isSmsSelected={isSmsSelected}
          isRecaptchaError={isRecaptchaError}
        />
      )}
      {fullPageView && !isSmsSelected && (
        <>
          <ResetPasswordResendEmail
            resendEmail={resendEmail}
            lblCodeNotReceived={lblPhoneOtpNotReceived}
            lblResentCode={lblResendIt}
            isSmsSelected={isSmsSelected}
            isResetViaText={isResetViaText}
          />
        </>
      )}
      {fullPageView && isSmsSelected && (
        <ResetPasswordResendEmail
          resendEmail={resendEmail}
          lblCodeNotReceived={lblPhoneOtpNotReceived}
          lblResentCode={lblResendIt}
          isSmsSelected={isSmsSelected}
          isResetViaText={isResetViaText}
        />
      )}
      <ResetPasswordForm
        successMessage={successMessage}
        errorMessage={errorMessage}
        onSubmit={onSubmit}
        onBack={onBack}
        resetPasswordErrorMessage={resetPasswordErrorMessage}
        showNotification={showNotification}
        isFormSubmitting={isFormSubmitting}
        passwordValidationCodeValid={passwordValidationCodeValid}
        fullPageView={fullPageView}
        showRecaptcha={showRecaptcha}
        codeExpired={codeExpired}
        resetStateAction={resetStateAction}
        resendEmail={resendEmail}
        verificationCodeSent={verificationCodeSent}
        setVerificationCodeSent={setVerificationCodeSent}
        resentMessageThreshold={resentMessageThreshold}
        selectedPassResetOption={selectedPassResetOption}
        isResetViaText={isResetViaText}
        isRecaptchaError={isRecaptchaError}
        setIsShowRecaptchaError={setIsShowRecaptchaError}
        isShowRecaptchaError={isShowRecaptchaError}
        isSafari={isSafari}
        loginInprogress={loginInprogress}
      />

      {showSMSOption && fullPageView && !isSmsSelected && !isCanada() && (
        <>
          {isResetViaText && maskedPhoneNumber !== '' && (
            <div className="send-via-phone elem-mt-LRG">
              <ResetPasswordResendEmail
                resendEmail={() => resendViaOption('sms')}
                lblCodeNotReceived={lblDidntReceiveOtpPhone}
                lblResentCode={lblSendCodeViaPhone}
                isSmsSelected={isSmsSelected}
                isResetViaText={isResetViaText}
              />
            </div>
          )}
        </>
      )}
      {fullPageView && isSmsSelected && (
        <div className="send-via-email elem-mt-LRG">
          <ResetPasswordResendEmail
            resendEmail={() => resendViaOption('email')}
            lblCodeNotReceived={lblDidntReceiveOtpPhone}
            lblResentCode={lblSendCodeViaEmail}
            isSmsSelected={isSmsSelected}
            isResetViaText={isResetViaText}
          />
        </div>
      )}
    </React.Fragment>
  );
};

ResetPassword.propTypes = {
  successMessage: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  resetPasswordErrorMessage: PropTypes.string.isRequired,
  showNotification: PropTypes.bool.isRequired,
  isFormSubmitting: PropTypes.bool.isRequired,
  passwordValidationCodeValid: PropTypes.bool,
  setpasswordValidationCode: PropTypes.func,
  fullPageView: PropTypes.bool,
  email: PropTypes.string,
  showRecaptcha: PropTypes.bool,
  resetPasswordAction: PropTypes.func,
  codeExpired: PropTypes.bool,
  resetStateAction: PropTypes.func,
  resentMessageThreshold: PropTypes.number,
  selectedPassResetOption: PropTypes.string,
  isRecaptchaError: PropTypes.bool,
  setIsShowRecaptchaError: PropTypes.func,
  isShowRecaptchaError: PropTypes.bool,
};

ResetPassword.defaultProps = {
  passwordValidationCodeValid: true,
  setpasswordValidationCode: () => {},
  fullPageView: false,
  email: '',
  showRecaptcha: false,
  resetPasswordAction: () => {},
  codeExpired: false,
  resetStateAction: () => {},
  resentMessageThreshold: 3000,
  selectedPassResetOption: '',
  isRecaptchaError: false,
  setIsShowRecaptchaError: () => {},
  isShowRecaptchaError: false,
};

export default ResetPassword;
